import { Container } from '@acies/core';
import { CheckBox, Spacer, theme } from '@acies/ui';
import ListHeaderLabel from '../shared/list-header-label/list-header-label';
import { SCROLLBAR_WIDTH } from '../shared/scrollbar-width';

export default class PositionsListHeader extends Container {
	#checkBox!: CheckBox<unknown>;
	#positionLabel!: ListHeaderLabel;
	#typeLabel!: ListHeaderLabel;
	#keyLabel!: ListHeaderLabel;
	#descriptionLabel!: ListHeaderLabel;
	#heightLabel!: ListHeaderLabel;
	#widthLabel!: ListHeaderLabel;
	#countLabel!: ListHeaderLabel;
	#litraLabel!: ListHeaderLabel;
	#noteLabel!: ListHeaderLabel;
	#statusLabel!: ListHeaderLabel;
	#totalPriceLabel!: ListHeaderLabel;
	#spacer!: Spacer;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 32;
		// the scrollbar's width on the right, so the last column ends where the rows' last column does
		this.paddingHorizontal = [16, 16 + SCROLLBAR_WIDTH];
		this.alignment = 'left';
		this.gapHorizontal = 16;
		this.fill = theme.colors.fill.weak;
		this.cornerRadius = 8;
		this.clipContent = true;
		this.hideScrollbars = true;
	}

	public get checkBox(): CheckBox<unknown> {
		if (!this.#checkBox) {
			this.#checkBox = new CheckBox();
		}
		return this.#checkBox;
	}

	public get positionLabel(): ListHeaderLabel {
		if (!this.#positionLabel) {
			this.#positionLabel = new ListHeaderLabel();
			this.#positionLabel.text = 'Pos';
			this.#positionLabel.width = 56;
		}
		return this.#positionLabel;
	}

	public get typeLabel(): ListHeaderLabel {
		if (!this.#typeLabel) {
			this.#typeLabel = new ListHeaderLabel();
			this.#typeLabel.text = 'Type';
			this.#typeLabel.width = 72;
		}
		return this.#typeLabel;
	}

	public get keyLabel(): ListHeaderLabel {
		if (!this.#keyLabel) {
			this.#keyLabel = new ListHeaderLabel();
			this.#keyLabel.text = 'Nøgle';
			this.#keyLabel.width = 192;
		}
		return this.#keyLabel;
	}

	public get descriptionLabel(): ListHeaderLabel {
		if (!this.#descriptionLabel) {
			this.#descriptionLabel = new ListHeaderLabel();
			this.#descriptionLabel.text = 'Beskrivelse';
			this.#descriptionLabel.minWidth = 88;
			this.#descriptionLabel.width = 'fill';
		}
		return this.#descriptionLabel;
	}

	public get heightLabel(): ListHeaderLabel {
		if (!this.#heightLabel) {
			this.#heightLabel = new ListHeaderLabel();
			this.#heightLabel.text = 'Højde';
			this.#heightLabel.width = 72;
			this.#heightLabel.textAlignHorizontal = 'right';
		}
		return this.#heightLabel;
	}

	public get widthLabel(): ListHeaderLabel {
		if (!this.#widthLabel) {
			this.#widthLabel = new ListHeaderLabel();
			this.#widthLabel.text = 'Bredde';
			this.#widthLabel.width = 72;
			this.#widthLabel.textAlignHorizontal = 'right';
		}
		return this.#widthLabel;
	}

	public get countLabel(): ListHeaderLabel {
		if (!this.#countLabel) {
			this.#countLabel = new ListHeaderLabel();
			this.#countLabel.text = 'Antal';
			this.#countLabel.width = 56;
			this.#countLabel.textAlignHorizontal = 'right';
		}
		return this.#countLabel;
	}

	public get litraLabel(): ListHeaderLabel {
		if (!this.#litraLabel) {
			this.#litraLabel = new ListHeaderLabel();
			this.#litraLabel.text = 'Litra';
			this.#litraLabel.width = 128;
		}
		return this.#litraLabel;
	}

	public get noteLabel(): ListHeaderLabel {
		if (!this.#noteLabel) {
			this.#noteLabel = new ListHeaderLabel();
			this.#noteLabel.text = 'Note';
			this.#noteLabel.width = 48;
			this.#noteLabel.textAlignHorizontal = 'center';
		}
		return this.#noteLabel;
	}

	public get statusLabel(): ListHeaderLabel {
		if (!this.#statusLabel) {
			this.#statusLabel = new ListHeaderLabel();
			this.#statusLabel.text = 'Status';
			this.#statusLabel.width = 48;
			this.#statusLabel.textAlignHorizontal = 'center';
		}
		return this.#statusLabel;
	}

	public get totalPriceLabel(): ListHeaderLabel {
		if (!this.#totalPriceLabel) {
			this.#totalPriceLabel = new ListHeaderLabel();
			this.#totalPriceLabel.text = 'Total';
			this.#totalPriceLabel.width = 96;
			this.#totalPriceLabel.textAlignHorizontal = 'right';
		}
		return this.#totalPriceLabel;
	}

	public get spacer(): Spacer {
		if (!this.#spacer) {
			this.#spacer = new Spacer();
			this.#spacer.width = 18;
		}
		return this.#spacer;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.checkBox, this.positionLabel, this.typeLabel, this.keyLabel, this.descriptionLabel, this.widthLabel, this.heightLabel, this.countLabel, this.litraLabel, this.noteLabel, this.statusLabel, this.totalPriceLabel, this.spacer]);
	}
}
customElements.define('ac-positions-list-header', PositionsListHeader);
